import * as React from "react";

const StarFioFid = ({
  color = "#EE8113", // default color
  width = 26, // default width
  height = 26, // default height
  ...props
}: React.SVGProps<SVGSVGElement> & {
  color?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 26 26"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13 3L15.2619 8.73503C15.4707 9.26443 15.575 9.52913 15.7349 9.75233C15.8766 9.95018 16.0498 10.1234 16.2477 10.2651C16.4709 10.4249 16.7356 10.5293 17.265 10.7381L23 13L17.265 15.2619C16.7356 15.4707 16.4709 15.575 16.2477 15.7349C16.0498 15.8766 15.8766 16.0498 15.7349 16.2477C15.575 16.4709 15.4707 16.7356 15.2619 17.265L13 23L10.7381 17.265C10.5293 16.7356 10.4249 16.4709 10.2651 16.2477C10.1234 16.0498 9.95018 15.8766 9.75233 15.7349C9.52913 15.575 9.26443 15.4707 8.73503 15.2619L3 13L8.73503 10.7381C9.26443 10.5293 9.52913 10.4249 9.75233 10.2651C9.95018 10.1234 10.1234 9.95018 10.2651 9.75233C10.4249 9.52913 10.5293 9.26443 10.7381 8.73503L13 3Z"
      stroke="none"
      strokeWidth="5.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default StarFioFid;
